
import { Project, ExperienceItem, Recommendation, Certification, TechCategory, Profile} from './types';
import { AdvancedImage } from '@cloudinary/react';
import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import {getCldImageUrl} from './utils/cloudinary';
import { get } from 'lodash';


export const TECH_STACK: TechCategory[] = [
  {
    title: "Frontend",
    skills: ["TypeScript", "JavaScript", "JQuery", "Vue.js", "React", "Nuxt", "NextJS", "Bootstrap", "Tailwind", "Material UI"]
  },
  {
    title: "Backend",
    skills: ["PHP", "Laravel", "PostgreSQL", "MongoDB", "Firebase", "NodeJS", "C#", ".Net"]
  },
  {
    title: "DevOps",
    skills: ["AWS", "Docker", "Vercel", "Laravel Forge"]
  },
  {
    title: "Testing",
    skills: ["Jest", "Cypress", "Postman", "Mailtrap"]
  },
  {
    title: "Developer Tools",
    skills: ["Jira", "Slack", "VS Code", "Clickup", "Discord", "Figma", "Git", "Github"]
  }
];

export const PROJECTS: Project[] = [
  {
    title: "Quizzapp: Online Quiz Platform",
    description: "A web-based quiz application that allows users to take quizzes on various topics, track their scores, and compete with others in real-time.",
    image:  getCldImageUrl('Screenshot_2026-02-04_084107_z1kpfm'),
    tech: ["MongoDB", "Express.js", "React.js", "Node.js", "Tailwind"],
    link: "https://smart-record.vercel.app"
  },
  {
    title: "SmartRecord: Digital Class Records",
    description: "A digital class records management system for educational institutions.",
    image:  getCldImageUrl('SmartRecord_leafuh'),
    tech: ["MongoDB", "Express.js", "React.js", "Node.js", "Tailwind"],
    link: "https://smart-record.vercel.app"
  },
  {
    title: "Atomic Tracker",
    description: "Atomic Tracker is a minimalist, web-based habit manager designed for building small, incremental routines.",
    image: getCldImageUrl('Atomic_Tracker_g5uumc'),
    tech: ["React.js", "Javascript", "Typescript", "Tailwind", "Firebase"],
    link: "https://atomic-tracker-three.vercel.app"
  },
  {
    title: "MMA Holes",
    description: "MMAHoles.tv is the official website for The MMA-Holes, a popular digital media brand and YouTube channel dedicated to Mixed Martial Arts (MMA) and combat sports.",
    image: getCldImageUrl('MMA_Holes_klq0uu'),
    tech: ["Vue.js", "Javascript", "Typescript", "Laravel", "Nuxt", "MySQL", "Tailwind"],
    link: "https://mmaholes.tv"
  },
  {
    title: "Solar Energy Company Website",
    description: "A corporate website for a leading solar energy solutions provider",
    image: getCldImageUrl('Tusc_jwedxb'),
    tech: ["WordPress", "Elementor", "PHP", "JavaScript", "CSS"],
    link: "https://tuscsolar.com"
  },
  {
    title: "Outsourcing Company Website",
    description: "A professional website for a business process outsourcing company",
    image: getCldImageUrl('TESI_ITO_xazsqv'),
    tech: ["WordPress", "Elementor", "PHP", "JavaScript", "CSS"],
    link: "https://tesioutsourcing.com"
  },
  {
    title: "Conglomerate Company Website",
    description: "A professional website for a conglomerate company",
    image: getCldImageUrl('TDG_World_w6k3ss'),
    tech: ["WordPress", "Elementor", "PHP", "JavaScript", "CSS"],
    link: "https://tdgworld.com"
  },
];

export const EXPERIENCE: ExperienceItem[] = [
  {
    role: "Senior Software Engineer",
    company: "Qstrike Innovations Phils OPC",
    period: "Dec 2022 - Present",
    description: [
      "Leading a team of 10 developers in architecting scalable SaaS applications.",
      "Optimized database queries reducing latency by 45%.",
      "Spearheaded the migration from legacy PHP to modern Laravel microservices."
    ]
  },
  {
    role: "Information Technology Instructor",
    company: "Polytechnic University of the Philippines",
    period: "Mar 2023 - Present",
    description: [
      "Developed custom e-commerce solutions using React and Vue.js.",
      "Implemented automated CI/CD pipelines using Docker and AWS.",
      "Mentored junior developers and improved code quality through rigorous PR reviews."
    ]
  },
  {
    role: "Implementation Specialist / WordPress Developer",
    company: "Argosquad",
    period: "Jan 2021 - Dec 2022",
    description: [
      "Developed custom e-commerce solutions using React and Vue.js.",
      "Implemented automated CI/CD pipelines using Docker and AWS.",
      "Mentored junior developers and improved code quality through rigorous PR reviews."
    ]
  },
  {
    role: "PHP Laravel Developer",
    company: "Gleent, Inc.",
    period: "Sep 2020 - Dec 2020",
    description: [
      "Developed custom e-commerce solutions using React and Vue.js.",
      "Implemented automated CI/CD pipelines using Docker and AWS.",
      "Mentored junior developers and improved code quality through rigorous PR reviews."
    ]
  }
];

export const RECOMMENDATIONS: Recommendation[] = [
  {
    name: "Marianne Bernardino",
    role: "Assistant Manager at EY",
    content: "Mr. Alday is a very hard-working person who I have known since college. We've worked with projects and he didn't hesitate to stand up as the leader and give guidance and help to his every member. He has strong technical skills and is very humble about it. That's why he still thrives on learning and exploring new things every day.",
    avatar: "https://picsum.photos/seed/sarah/100/100"
  }
];

export const CERTIFICATIONS: Certification[] = [
  {
    title: "Introduction to Front-End Development",
    issuer: "Meta",
    date: "Dec 2025",
    link: "https://www.coursera.org/account/accomplishments/verify/XUW3PA088DBL",
    icon: "https://logos-world.net/wp-content/uploads/2021/11/Meta-Emblem.png"
  },
  {
    title: "Introduction to Generative AI",
    issuer: "Google Cloud Security",
    date: "Dec 2025",
    link: "https://www.coursera.org/account/accomplishments/verify/7MHRD1F71Q24",
  },
  {
    title: "Introduction to Mobile Development",
    issuer: "Meta",
    date: "Dec 2025",
    link: "https://www.coursera.org/account/accomplishments/verify/YQ378J8RALT3",
    icon: "https://logos-world.net/wp-content/uploads/2021/11/Meta-Emblem.png"
  },
  {
    title: "AWS Academy Graduate - AWS Academy Cloud Foundations",
    issuer: "Amazon Web Services (AWS)",
    date: "Oct 2022",
    link: "https://www.credly.com/badges/565e3ebf-f48f-44f3-8f1d-92365a88651e/linked_in_profile"
  },
  {
    title: "Advanced Javascript",
    issuer: "Village88, Inc. - Philippines",
    date: "Sep 2022",
    link: "https://drive.google.com/file/d/1Qgrg_KLTUpXGZwWAAJ-1pjfPr3kRVdqQ/view"
  },
  {
    title: "Advanced PHP",
    issuer: "Village88, Inc. - Philippines",
    date: "Aug 2022",
    link: "https://drive.google.com/file/d/1N1DXDx3HVVAs5QxDjA9aOEgXI3g87qYL/view"
  },
  {
    title: "Web Fundamentals",
    issuer: "Village88, Inc. - Philippines",
    date: "Jul 2022",
    link: "https://drive.google.com/file/d/1_t7kX0alZGvKmeeezy7Qgg31VbZJ75IF/view"
  },
  {
    title: "Javascript Algorithms and Data Structures",
    issuer: "FreeCodeCamp",
    date: "Jul 2021",
    link: "https://www.freecodecamp.org/certification/kimvincent09/javascript-algorithms-and-data-structures"
  },
  {
    title: "Responsive Web Design",
    issuer: "FreeCodeCamp",
    date: "Jul 2021",
    link: "https://www.freecodecamp.org/certification/kimvincent09/responsive-web-design"
  },
  {
    title: "Foundations of User Experience (UX) Design",
    issuer: "Google",
    date: "Mar 2021",
    link: "https://www.coursera.org/account/accomplishments/certificate/JN987LTAWD6F"
  },
  {
    title: "Online Masterclass on Agile Development and Organizations",
    issuer: "Asian Institute of Management",
    date: "Jul 2020",
    link: "https://drive.google.com/file/d/1wPYFTSjS1f3H71mM_ZcS_EgO-1Yz28gf/view?usp=drive_link"
  },
  {
    title: "Web Development Level III",
    issuer: "TESDA: Technical Education and Skills Development Authority",
    date: "Dec 2019",
    link: "https://drive.google.com/file/d/1Tx_-XqXojHpKGIM-VbIKxdYgxv9e2Spa/view"
    
  },
];

/**
 * These are initial images. 
 * Once you upload via the widget, new Cloudinary URLs will be added to this list in the UI.
 */
export const GALLERY_IMAGES = [
  getCldImageUrl('ALDAY_KIM_VINCENT_r7sroh'),

];

export const PROFILE: Profile = {
  name: "Kim Vincent Alday",
  role: "Full Stack Developer",
  bio: "Passionate full stack developer with expertise in Laravel, Vue.js, and React.js. I build scalable web applications and lead development teams.",
  avatar: getCldImageUrl('viber_image_2026-02-04_12-28-47-165_vei3yh'),
  avatar2: getCldImageUrl('grad_pic_rtkwns'),
};